import { Button } from "PFComponents/button";
import { Icon } from "PFComponents/icon";
import { getProfileName } from "PFCore/helpers/profile";
import useBookingCategories from "PFCore/hooks/use_booking_categories";
import { Booking } from "PFTypes";
import React, { useContext } from "react";

import AppContext from "../../../../app_context";
import { useDeleteBookingModalContext } from "../../../../booking/components/delete_booking_modal/delete_booking_modal_context_provider";
import { useProfileBookingsContext } from "../../profile_bookings_provider";
import css from "./action_column.module.scss";

type ActionColumnProps = {
  booking: Booking;
  readOnly: boolean;
  onEdit: (booking: Booking) => void;
};
export const ActionColumn = ({ booking, readOnly, onEdit }: ActionColumnProps): JSX.Element => {
  const {
    store: { currentProfile }
  } = useContext(AppContext);

  const { getCategory } = useBookingCategories();
  const category = getCategory(booking);

  const { refreshBookings } = useProfileBookingsContext();

  const { modal } = useDeleteBookingModalContext();
  const isReadOnly = readOnly || booking.readonly || booking.source !== "ui";

  return (
    <div className={css.root}>
      {!isReadOnly && !!category && (
        <>
          <Button
            kind="blank"
            onClick={(event) => {
              event.stopPropagation();
              onEdit(booking);
            }}
          >
            <Icon name="edit" size="sm" />
          </Button>
          <Button
            kind="blank"
            onClick={(event) => {
              event.stopPropagation();
              modal.open({
                booking,
                deleteMode: "SINGLE_BOOKING",
                profileFullName: getProfileName(currentProfile),
                onDeleted: () => {
                  refreshBookings();
                  return Promise.resolve();
                }
              });
            }}
          >
            <Icon name="remove" size="sm" />
          </Button>
        </>
      )}
    </div>
  );
};
